import {
  FIRST_FORWARD_COLUMN_LEGEND,
  FIRST_NON_FORWARD_COLUMN_LEGEND,
  MEAN_ALIAS,
  MEDIAN_ALIAS,
  PERCENTILE_SELECTION_A_ALIAS,
  PERCENTILE_SELECTION_B_ALIAS,
  SECOND_FORWARD_COLUMN_LEGEND,
  SECOND_NON_FORWARD_COLUMN_LEGEND,
} from '../../constants';

export const LAST_MIDDLE_COLUMN_INDEX = 3;
export const STOCK_PRICE_KEY = 'stock_price';

// Relative row numbers from the forward multiple discount row when it is enabled
export const RELATIVE_MEDIAN_ROW_NUMBER = 1;
export const RELATIVE_MEAN_ROW_NUMBER = 2;
export const RELATIVE_PERCENTILE_SELECTION_A_ROW_NUMBER = 5;
export const RELATIVE_PERCENTILE_SELECTION_B_ROW_NUMBER = 6;

export const COMPANY_REVENUE_ROW_NUMBER = 12; 
export const MULTIPLE_TYPE_ROW_NUMBER = 13;
export const APPLIED_MULTIPLE_ROW_NUMBER = 15;

export const FORWARD_COLUMN_MAP: Record<string, string> = {
  [FIRST_FORWARD_COLUMN_LEGEND]: FIRST_NON_FORWARD_COLUMN_LEGEND,
  [SECOND_FORWARD_COLUMN_LEGEND]: SECOND_NON_FORWARD_COLUMN_LEGEND,
};

export const METRIC_OFFSET_BY_ALIAS: Record<string, number> = {
  [MEDIAN_ALIAS]: RELATIVE_MEDIAN_ROW_NUMBER,
  [MEAN_ALIAS]: RELATIVE_MEAN_ROW_NUMBER,
  [PERCENTILE_SELECTION_A_ALIAS]: RELATIVE_PERCENTILE_SELECTION_A_ROW_NUMBER,
  [PERCENTILE_SELECTION_B_ALIAS]: RELATIVE_PERCENTILE_SELECTION_B_ROW_NUMBER,
};
